import { maxSpacingValue as o, minSpacingValue as s } from "../../theme/spacing.js";
import { isBetweenInclusive as c } from "../isBetweenInclusive/index.js";
import '../../assets/index5.css';const j = "_m0_127qj_2", q = "_m1_127qj_6", r = "_m2_127qj_10", l = "_m3_127qj_14", b = "_m4_127qj_18", e = "_m5_127qj_22", i = "_m6_127qj_26", u = "_m7_127qj_30", a = "_m8_127qj_34", f = "_m9_127qj_38", g = "_m10_127qj_42", S = "_mt0_127qj_50", y = "_mt1_127qj_54", v = "_mt2_127qj_58", x = "_mt3_127qj_62", C = "_mt4_127qj_66", V = "_mt5_127qj_70", $ = "_mt6_127qj_74", k = "_mt7_127qj_78", w = "_mt8_127qj_82", B = "_mt9_127qj_86", I = "_mt10_127qj_90", K = "_mr0_127qj_98", d = "_mr1_127qj_102", h = "_mr2_127qj_106", z = "_mr3_127qj_110", A = "_mr4_127qj_114", D = "_mr5_127qj_118", E = "_mr6_127qj_122", F = "_mr7_127qj_126", G = "_mr8_127qj_130", H = "_mr9_127qj_134", J = "_mr10_127qj_138", L = "_mb0_127qj_146", M = "_mb1_127qj_150", N = "_mb2_127qj_154", O = "_mb3_127qj_158", P = "_mb4_127qj_162", Q = "_mb5_127qj_166", R = "_mb6_127qj_170", T = "_mb7_127qj_174", U = "_mb8_127qj_178", W = "_mb9_127qj_182", X = "_mb10_127qj_186", Y = "_ml0_127qj_194", Z = "_ml1_127qj_198", __ = "_ml2_127qj_202", t_ = "_ml3_127qj_206", p_ = "_ml4_127qj_210", m_ = "_ml5_127qj_214", n_ = "_ml6_127qj_218", o_ = "_ml7_127qj_222", s_ = "_ml8_127qj_226", c_ = "_ml9_127qj_230", j_ = "_ml10_127qj_234", q_ = "_p0_127qj_239", r_ = "_p1_127qj_243", l_ = "_p2_127qj_247", b_ = "_p3_127qj_251", e_ = "_p4_127qj_255", i_ = "_p5_127qj_259", u_ = "_p6_127qj_263", a_ = "_p7_127qj_267", f_ = "_p8_127qj_271", g_ = "_p9_127qj_275", S_ = "_p10_127qj_279", y_ = "_pt0_127qj_287", v_ = "_pt1_127qj_291", x_ = "_pt2_127qj_295", C_ = "_pt3_127qj_299", V_ = "_pt4_127qj_303", $_ = "_pt5_127qj_307", k_ = "_pt6_127qj_311", w_ = "_pt7_127qj_315", B_ = "_pt8_127qj_319", I_ = "_pt9_127qj_323", K_ = "_pt10_127qj_327", d_ = "_pr0_127qj_335", h_ = "_pr1_127qj_339", z_ = "_pr2_127qj_343", A_ = "_pr3_127qj_347", D_ = "_pr4_127qj_351", E_ = "_pr5_127qj_355", F_ = "_pr6_127qj_359", G_ = "_pr7_127qj_363", H_ = "_pr8_127qj_367", J_ = "_pr9_127qj_371", L_ = "_pr10_127qj_375", M_ = "_pb0_127qj_383", N_ = "_pb1_127qj_387", O_ = "_pb2_127qj_391", P_ = "_pb3_127qj_395", Q_ = "_pb4_127qj_399", R_ = "_pb5_127qj_403", T_ = "_pb6_127qj_407", U_ = "_pb7_127qj_411", W_ = "_pb8_127qj_415", X_ = "_pb9_127qj_419", Y_ = "_pb10_127qj_423", Z_ = "_pl0_127qj_431", _1 = "_pl1_127qj_435", t1 = "_pl2_127qj_439", p1 = "_pl3_127qj_443", m1 = "_pl4_127qj_447", n1 = "_pl5_127qj_451", o1 = "_pl6_127qj_455", s1 = "_pl7_127qj_459", c1 = "_pl8_127qj_463", j1 = "_pl9_127qj_467", q1 = "_pl10_127qj_471", r1 = {
  m0: j,
  m1: q,
  m2: r,
  m3: l,
  m4: b,
  m5: e,
  m6: i,
  m7: u,
  m8: a,
  m9: f,
  m10: g,
  mt0: S,
  mt1: y,
  mt2: v,
  mt3: x,
  mt4: C,
  mt5: V,
  mt6: $,
  mt7: k,
  mt8: w,
  mt9: B,
  mt10: I,
  mr0: K,
  mr1: d,
  mr2: h,
  mr3: z,
  mr4: A,
  mr5: D,
  mr6: E,
  mr7: F,
  mr8: G,
  mr9: H,
  mr10: J,
  mb0: L,
  mb1: M,
  mb2: N,
  mb3: O,
  mb4: P,
  mb5: Q,
  mb6: R,
  mb7: T,
  mb8: U,
  mb9: W,
  mb10: X,
  ml0: Y,
  ml1: Z,
  ml2: __,
  ml3: t_,
  ml4: p_,
  ml5: m_,
  ml6: n_,
  ml7: o_,
  ml8: s_,
  ml9: c_,
  ml10: j_,
  p0: q_,
  p1: r_,
  p2: l_,
  p3: b_,
  p4: e_,
  p5: i_,
  p6: u_,
  p7: a_,
  p8: f_,
  p9: g_,
  p10: S_,
  pt0: y_,
  pt1: v_,
  pt2: x_,
  pt3: C_,
  pt4: V_,
  pt5: $_,
  pt6: k_,
  pt7: w_,
  pt8: B_,
  pt9: I_,
  pt10: K_,
  pr0: d_,
  pr1: h_,
  pr2: z_,
  pr3: A_,
  pr4: D_,
  pr5: E_,
  pr6: F_,
  pr7: G_,
  pr8: H_,
  pr9: J_,
  pr10: L_,
  pb0: M_,
  pb1: N_,
  pb2: O_,
  pb3: P_,
  pb4: Q_,
  pb5: R_,
  pb6: T_,
  pb7: U_,
  pb8: W_,
  pb9: X_,
  pb10: Y_,
  pl0: Z_,
  pl1: _1,
  pl2: t1,
  pl3: p1,
  pl4: m1,
  pl5: n1,
  pl6: o1,
  pl7: s1,
  pl8: c1,
  pl9: j1,
  pl10: q1
};
function e1(_) {
  const t = {};
  if (typeof _ != "object")
    return t;
  for (const p in _) {
    const m = _[p];
    if (c(m, s, o)) {
      const n = `${p}${String(m)}`;
      t[r1[n]] = !0;
    }
  }
  return t;
}
export {
  e1 as getSpacingClasses
};
